import { Injectable } from '@angular/core';

import { ILayoutMicrofrontend } from '../../models/layout/layout-microfrontend.interface';
import { IServiceResponseWidgets } from '../../models/services/response-app/response-app-widgets.interface';
import { StoreService } from '../../services/store/store.service';

@Injectable({
  providedIn: 'root'
})
export class ScriptStatusHelper {
  errorReference = {};
  loadedReference = {};

  constructor(private storeService: StoreService) {}

  /**
   * Sets scripts status
   * @param microfrontend: Informação do mfe widget usado para referência
   */
  setScriptsStatus(microfrontend: ILayoutMicrofrontend | IServiceResponseWidgets) {
    this.storeService.scriptList.subscribe((res: any) => {
      res[microfrontend.tag_html]
        ? this.setLoaderStatus(microfrontend.tag_html, res[microfrontend.tag_html])
        : this.setErrorStatus(microfrontend.tag_html, res[microfrontend.tag_html]);
    });
  }

  /**
   * Sets mfe status to hide loader
   * @param mfeRef id de referência do microfrontend
   * @param mfeStatus status do mfe
   */
  setLoaderStatus(mfeRef: string, mfeStatus: boolean) {
    // @ts-ignore
    this.loadedReference[mfeRef] = mfeStatus;
  }

  /**
   * Sets mfe status to display error if necessary
   * @param mfeRef id de referência do microfrontend
   * @param mfeStatus status do mfe
   */
  setErrorStatus(mfeRef: string, mfeStatus: boolean | undefined) {
    if (mfeStatus !== undefined) {
      // @ts-ignore
      this.errorReference[mfeRef] = true;
    }
  }
}
